import analyticsConfig from '../../../../server/config/analytics';
import logger from '../../../../services/logger_service';

export default function ga(context) {
  const siteConfig = analyticsConfig[context.site];

  if (siteConfig === undefined) {
    logger.error(
      'GA IS NOT LOADING ON THIS PAGE BECAUSE SITECONFIG IS UNDEFINED'
    );
    return '';
  }

  const gaConfig = siteConfig.googleAnalytics;

  const { webPropertyId, rollupPropertyId } = gaConfig;

  return `
  <script>
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

    ga('create', '${webPropertyId}', 'auto');
    ga('create', '${rollupPropertyId}', 'auto', {'name': 'rollup'});
    ga('send', 'pageview');
    ga('rollup.send', 'pageview');
  </script>`;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/ga.js